
















































export default {
  name: "BaseSimpleSlider",
  data: function () {
    return {
      isGrabbing: false,
      timeBeforeGrabbing: 0,
      collectedMovementX: 0,
      isShowModal: false,
      isActive: false,
      localValue: 0,
      progress: 0,
      roundedProgress: 0,
    };
  },
  props: {
    value: {
      type: Number,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
    isColorSlider: {
      type: Boolean,
      default: false,
    },
    normalValue: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.localValue = this.value;
  },
  watch: {
    value: function () {
      this.localValue = this.value;
    },
  },
  computed: {
    positionPlayhead: function () {
      const percentFromLeft =
        ((this.localValue - this.min) * 100) / (this.max - this.min);

      return percentFromLeft < 0
        ? percentFromLeft
        : percentFromLeft > 100
        ? 100
        : percentFromLeft;
    },
    positionNormalValue: function () {
      if (this.normalValue === null) {
        return null;
      }
      const percentFromLeft =
        ((this.normalValue - this.min) * 100) / (this.max - this.min);

      return percentFromLeft < 0
        ? percentFromLeft
        : percentFromLeft > 100
        ? 100
        : percentFromLeft;
    },
  },
  methods: {
    clickOnProgressBar(event) {
      const fullWidth = event.target.getBoundingClientRect().width;
      const clickWidth = event.offsetX;
      this.progress =
        this.min + ((this.max - this.min) * clickWidth) / fullWidth;
      this.roundedProgress = Math.round(this.progress / this.step) * this.step;
      this.$emit("change", this.roundedProgress);
      this.localValue = this.roundedProgress;
    },
    startGrab(event) {
      event.stopPropagation();
      this.isGrabbing = true;
      this.timeBeforeGrabbing = this.localValue;
      window.onmousemove = this.moveCursorAt.bind(event);
      window.onmouseup = this.stopGrab.bind(event);

      this.isActive = true;
    },
    moveCursorAt(event) {
      this.collectedMovementX += event.movementX;

      this.progress =
        this.timeBeforeGrabbing +
        (this.collectedMovementX / this.$refs.player.offsetWidth) *
          (this.max - this.min);
      this.progress =
        this.progress < this.min
          ? this.min
          : this.progress > this.max
          ? this.max
          : this.progress;

      this.roundedProgress = Math.round(this.progress / this.step) * this.step;
      this.roundedProgress =
        this.roundedProgress < this.min
          ? this.min
          : this.roundedProgress > this.max
          ? this.max
          : this.roundedProgress;

      this.localValue = this.progress;
      this.$emit("change", this.roundedProgress);
    },
    stopGrab() {
      this.isGrabbing = false;
      this.collectedMovementX = 0;
      this.timeBeforeGrabbing = 0;
      window.onmouseup = null;
      window.onmousemove = null;

      this.localValue = this.roundedProgress;
    },
    onMouseOut() {
      if (this.isActive) {
        this.isShowModal = true;
      }
    },
    onMouseUp() {
      if (this.isActive) {
        this.isActive = false;
        this.isShowModal = false;
      }
    },
  },
};
